module.exports = __webpack_public_path__ + "img/salad.e5e4a9b4.png";